// Detect the correct backend URL based on current domain
export const getBackendUrl = () => {
  const currentHost = window.location.hostname;
  const currentOrigin = window.location.origin;
  
  // Debug log
  console.log('Detecting backend URL for host:', currentHost);
  
  // If accessing via custom domain (not localhost or preview), use same origin
  if (currentHost !== 'localhost' && 
      !currentHost.includes('127.0.0.1') &&
      !currentHost.includes('preview.emergentagent.com')) {
    console.log('Using same-origin backend:', currentOrigin);
    return currentOrigin;
  }
  
  // Fallback to environment variable
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  console.log('Using env backend URL:', envUrl);
  return envUrl;
};

export const getApiUrl = () => `${getBackendUrl()}/api`;

// Export both as constants and functions for flexibility
export const BACKEND_URL = getBackendUrl();
export const API = getApiUrl();

// Log on module load
console.log('API Configuration:', { BACKEND_URL, API });
